import React from "react";
import moment from "moment";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const ageInStatusColumn = () => ({
	Header: "Age in Status",
	accessor: "ageInStatus",
	Cell: ({ row }: TableCellProp<Application>) => {
		const startDate = row.original?.application_status_started_at;
		const dateTime = moment
			.utc(startDate)
			.local()
			.format("MM/DD/YY h:mm A");
		const duration = moment.utc(startDate).local().fromNow(true);

		if (startDate)
			return (
				<div>
					<div className="hide-laptop">{dateTime}</div>
					<div className="cut-text-laptop">
						<OverflowTooltip onlyOnLaptop title={duration}>
							{duration}
						</OverflowTooltip>
					</div>
				</div>
			);
		else return "No data";
	},
});

export default ageInStatusColumn;
